import { render, staticRenderFns } from "./essays-table.vue?vue&type=template&id=2d2b6a30"
import script from "./essays-table.vue?vue&type=script&lang=js"
export * from "./essays-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports